import './utils/wdyr'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'

import App from './App'
// import ScrollToTop from './components/ScrollToTop';
import * as serviceWorker from './utils/serviceWorker'
import { QueryController } from './contexts/queryContext'
import { QuizController } from './contexts/quizContext'

import './css/index.css'
import './css/App.css'
import './css/styles.css'
import './css/quiz.css'
import './css/results.css'
import { initializeAnalytics } from './utils/analytics'

initializeAnalytics()

const app = (
  <>
    <title>Podcast Style Quiz</title>
    <Router>
      <QueryController>
        <QuizController>
          {/* <ScrollToTop /> */}
          <App />
        </QuizController>
      </QueryController>
    </Router>
  </>
)

// for helping to find rerender bugs (strictMode renders twice)
// ReactDOM.render(app, document.getElementById('root'))

//https://stackoverflow.com/questions/48846289/why-is-my-react-component-is-rendering-twice
const strictMode = <React.StrictMode>{app}</React.StrictMode>
ReactDOM.render(strictMode, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
